import { Injectable, Type } from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';

const defaultModalOptions: NgbModalOptions = {
  size: 'md',
  centered: true,
};

@Injectable({
  providedIn: 'root',
})
export class ModalUtilsService {
  constructor(private modalService: NgbModal) {}

  openModal<T>(component: Type<T>, options?: NgbModalOptions) {
    let opts = { ...defaultModalOptions, ...options };
    return this.modalService.open(component, {
      ...opts,
    }) as Omit<NgbModalRef, 'componentInstance'> & {
      componentInstance: T;
    };
  }
}
